export enum AlertState {
  Created = 'created',
  DataComplete = 'data_complete',
  Approved = 'approved',
  Sent = 'sent',
}
